/**
 * A camada de implantacao.
 *
 * O curso e um combo: quem executa no plantao e quem implanta na unidade, no
 * mesmo conteudo. Esta aba e a metade que fala com quem coordena, e e o que
 * impede o site de vender ferramenta sem dizer como fazer pegar.
 *
 * O caso do checklist vem do framework de psicologia da mudanca do IHI, que e
 * material publico. A instituicao do caso nao e nomeada de proposito: a regra
 * do projeto proibe citar concorrente, e aqui a instituicao nao acrescenta
 * nada ao argumento. A fonte, sim, aparece na pagina.
 */

/** A objecao que abre a aba. E a frase que os facilitadores mais ouvem. */
export const implantacao = {
  objecao: 'Isso não funciona no meu hospital',
  enquadramento:
    'É uma das frases que mais ouvimos quando falamos de ferramentas de segurança. Na Imersão HCRM, ela não é tratada como resistência. É parte do conteúdo.',
  tecnicoAdaptativo:
    'Ensinar SBAR é relativamente simples. Fazer com que uma equipe utilize SBAR quando há pressão, pouco tempo, conflito ou forte hierarquia é outra história. Por isso, aprender a ferramenta é apenas parte do processo. É preciso compreender o que favorece e o que impede sua utilização na prática.',
  perguntaDasBarreiras:
    'Elas são previsíveis e estão descritas nos referenciais utilizados durante a formação. Qual delas existe hoje na sua equipe?',
  tituloDoCaso: 'Adesão não se impõe. É preciso construí-la.',
  caso: 'Em um sistema de saúde norte-americano, a adesão a um checklist de segurança cirúrgica permanecia em cerca de 30% após 18 meses de esforços de implementação. A estratégia mudou quando o foco deixou de estar apenas na ferramenta e passou a incluir as pessoas envolvidas na mudança. Profissionais foram ouvidos individualmente sobre suas percepções e preocupações. Também foram convidados a participar da implementação. Ao longo do processo, mais de 700 profissionais participaram desses encontros. A instituição relatou alcançar 100% de adoção sustentada do checklist cirúrgico.',
  remateDoCaso: 'A ferramenta era a mesma. O que mudou foi a forma de implementar a mudança.',
  fonte:
    'Hilton K, Anderson A. IHI Psychology of Change Framework to Advance and Sustain Improvement. Institute for Healthcare Improvement, 2018.',
  tituloDaVolta: 'E quando você voltar para a sua unidade?',
  volta:
    'Aprender SBAR, CUS, huddles ou debriefing é apenas o começo. Para que essas ferramentas façam parte do trabalho cotidiano, é preciso compreender barreiras, contexto e comportamento da equipe. Na Imersão HCRM, você também discutirá como reconhecer barreiras à implementação e planejar a introdução dessas práticas na realidade da sua equipe.',
  remateDaVolta:
    'A proposta não é voltar ao hospital com uma lista de ferramentas. É voltar sabendo por onde começar.',
} as const;

/** As barreiras previsiveis, com o nome que o framework da a cada uma. */
export const barreiras: string[] = [
  'Hierarquia',
  'Falta de tempo',
  'Defensividade',
  'Complacência',
  'Diferentes estilos de comunicação',
  'Conflitos não resolvidos',
  'Distrações',
  'Fadiga',
  'Falta de clareza de papéis',
];
